import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "d2dc1822-5d32-11ee-8c99-0242ac120002",
    content: "A loudspeaker reproduction of ambisonics signals is not possible.",
    options: {},
  },
  {
    id: "d2dc1cbe-5d32-11ee-8c99-0242ac120002",
    content: "An ambisonics signal stream consists of (N+1)2 channels, where N = ambisonics order.",
    options: {},
  },
  {
    id: "d2dc1e44-5d32-11ee-8c99-0242ac120002",
    content: "Ambisonics is a compressed audio format similar to MP3.",
    options: {},
  },
  {
    id: "d2dc1f84-5d32-11ee-8c99-0242ac120002",
    content: "Ambisonics is not a channel-based format.",
    options: {},
  },
  {
    id: "ee384050-5d32-11ee-8c99-0242ac120002",
    content: "The minimum number of loudspeakers required for reproduction is order dependent.",
    options: {},
  },
  {
    id: "f52ca9be-5d32-11ee-8c99-0242ac120002",
    content: "Only a static binaural reproduction over headphones is possible.",
    options: {},
  },
];

export const task: Task = {
  id: "f9f34f3e-5d32-11ee-8c99-0242ac120002",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "d2dc1cbe-5d32-11ee-8c99-0242ac120002",
    "d2dc1f84-5d32-11ee-8c99-0242ac120002",
    "ee384050-5d32-11ee-8c99-0242ac120002",
  ],
};
